import { AuthenticationService } from '../core/services/auth.service';
import { Component } from '@angular/core';
import { ComponentAccessUserService } from '../core/services/utelize/system/component-access/component-access-user-service';
import { ExceptionsService } from '../core/services/utelize/general/exceptions-service';
import { OurCompany } from '../core/consts';
import { Router } from '@angular/router';

@Component({
  selector: 'app-platform-landing',
  templateUrl: './platform-landing.component.html',
  styleUrls: ['./platform-landing.component.scss']
})
export class PlatformLandingComponent {
  public companyName: string =OurCompany.CompanyNamePascal;
  public displayName: string ='User';
  public orbit      : boolean=false;

  get dashboardUrl() { return this.componentAccessUserService.dashboardUrl; }

  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private exceptionsService         : ExceptionsService,
    private router                    : Router
  ) {
    const currentUser=this.authenticationService.currentUserObject();
    const parts      =[currentUser.firstname, currentUser.lastname].filter(Boolean);

    if (parts.length>0) {
      this.displayName=parts.join(' ');

    } else if (currentUser.username) {
      this.displayName=currentUser.username;

    }
  }

  public logout(): void {
    try {
      this.authenticationService.logout();
      this.router.navigate(['/auth/login']);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleOrbit(): void {
    try {
      this.orbit=!this.orbit;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
